import { format, parseISO } from 'date-fns'

import { getObjectsSum } from '../../utils/common'

import { BIRDVIEW_AGE_RANGE_LAST_DAY_OFFSET } from './DashboardBirdview.constants'
import {
  BIRDVIEW_CHART_DATE_FORMAT,
  BirdviewAgingBasis,
  BirdviewChartMetric,
  BirdviewKpiUnit,
  BirdviewTrend,
} from './DashboardBirdview.constants.charts'

function checkHasBirdviewChartItemValue(item) {
  return item.value > 0
}

export function formatBirdviewChartDate(date) {
  return format(parseISO(date), BIRDVIEW_CHART_DATE_FORMAT)
}

export function getBirdviewTrend(delta) {
  if (delta > 0) {
    return BirdviewTrend.Up
  }

  if (delta < 0) {
    return BirdviewTrend.Down
  }

  return BirdviewTrend.Flat
}

export function formatBirdviewKpiValue({ t, unit, value }) {
  switch (unit) {
    case BirdviewKpiUnit.Days:
      return t('DashboardBirdview.RelativeTimeDaysKey', { count: value })
    case BirdviewKpiUnit.Hours:
      return t('DashboardBirdview.RelativeTimeHoursKey', { count: value })
    case BirdviewKpiUnit.Percent:
      return `${value}%`
    default:
      return String(value)
  }
}

export function checkIsBirdviewCountMetric(metric) {
  return metric === BirdviewChartMetric.Count
}

export function checkIsBirdviewPerUnitsMetric(metric) {
  return metric === BirdviewChartMetric.PerUnits
}

export function checkIsBirdviewAvgTimeMetric(metric) {
  return metric === BirdviewChartMetric.AvgTime
}

export function checkIsBirdviewActivityAgingBasis(basis) {
  return basis === BirdviewAgingBasis.Activity
}

// An all-zero chart reads as empty.
export function toBirdviewChartSection(items) {
  const shown = items.filter(checkHasBirdviewChartItemValue)

  return { items: shown, total: getObjectsSum(shown) }
}

export function toBirdviewSeriesSection(points) {
  return { items: points, total: points.length }
}

// The upper bound is exclusive, so the label names the last day still covered.
export function getBirdviewAgeRangeLabelParams({ maxDays, minDays }) {
  return {
    ...(maxDays ? { max: maxDays - BIRDVIEW_AGE_RANGE_LAST_DAY_OFFSET } : null),
    min: minDays,
  }
}
